var mixer;
var isInit = true;
var isNewDetail = true;

jQuery(document).ready(function($) {

	var griditems = jQuery(".collection-list");

	mixer = mixitup(griditems, {
		behavior: {
			liveSort: true
		},
      animation: {
         enable: false
      },
		load: {
         filter: ".pt-create",
				 sort: 'price:desc'
		},
      controls: {
        live: true
      },
		multifilter: {
			enable: true
		},
      debug: {
        enable: true,
        showWarnings: true
     },
      pagination: {
         limit: 150
      },
      templates: {
         pageStats: '${totalTargets} Results'
      },

		callbacks: {
         onParseFilterGroups: function(command) {
            console.log(command.filter.selector);

            if ( ((command.filter.selector.includes(".pt-start")) || (command.filter.selector.includes(".pt-bp"))) && (command.filter.selector.length > 12) ) {

							try {
	               mixer.setFilterGroupSelectors('plastic-material', '');
	               mixer.setFilterGroupSelectors('plastic-pla', '');

	               command.filter.selector = command.filter.selector.replace(".pt-flexy","");
	               command.filter.selector = command.filter.selector.replace(".pt-pla","");
	               command.filter.selector = command.filter.selector.replace(".pt-wood","");
	               command.filter.selector = command.filter.selector.replace(".pt-abs","");
	               command.filter.selector = command.filter.selector.replace(".pt-metallic","");
	               command.filter.selector = command.filter.selector.replace(".pt-clearly","");
							 }
							 catch(err) {
								 // different grid
							 }

            }

            return command;
         },
			onMixStart: function(e) {
				console.log("Before: " + e.activeFilter.selector);
			},
			onMixFail: function(e) {
            console.log("Fail:" + e);
			},
         onMixBusy: function() {
            console.log("Busy");
         },
         onMixBusy: function() {
            console.log("Click");
         },
			onMixEnd: function(e) {

				console.log("After: " + e.activeFilter.selector);

				if (e.activeFilter.selector == ".mix") {
           jQuery(".collection-filter__counter").text("0");
        } else {
           var count = e.activeFilter.selector.split(".").length - 1;
           jQuery(".collection-filter__counter").text(count);
           console.log(count);
        }

				var elm = document.getElementsByClassName("collection-filter")[0];
				removeClassByPrefix(elm, "cfactive");

				var activeClass = e.activeFilter.selector;

				if (activeClass.indexOf("bp") >= 0) { activeClass = "cfactive-bp"; $(".gridview__mobile").text("Build & Play");  }
				if (activeClass.indexOf("create") >= 0) { activeClass = "cfactive-create"; $(".gridview__mobile").text("Create"); }
				if (activeClass.indexOf("start") >= 0) { activeClass = "cfactive-start"; $(".gridview__mobile").text("Start"); }
				if (activeClass.indexOf("pro") >= 0) { activeClass = "cfactive-pro"; $(".gridview__mobile").text("Pro");}
				if (activeClass.indexOf("edu") >= 0) { activeClass = "cfactive-edu"; $(".gridview__mobile").text("EDU");}

				activeClass = activeClass.replace(".","");
				jQuery(".collection-filter").addClass(activeClass);

				//$("html, body").animate({ scrollTop: 0 }, "slow");



			},
		}
	});

   //getFilter();
	 jQuery(".filter-create").click();


});


jQuery(".collection-filter__mobile, .collection-filter__update").on("click", function() {
   $(".collection-filter__fields").toggle();
});

jQuery('.filter-bp, .filter-start').on("click", function() {
   jQuery(".collection-filter--createonly").prop("disabled", true);
});

jQuery('.filter-create').on("click", function() {
   jQuery(".collection-filter--createonly").prop("disabled", false);
});

jQuery('.filter-pro').on("click", function() {
   jQuery(".collection-filter--createonly").prop("disabled", false);
});

jQuery('.collection-filter__reset').on("mouseup", function() {

   setTimeout(function() {
      jQuery(".filter-start").click();
   }, 500);

});


//
// utility method to programmatically change filter(s)
//
function menuJump(v) {

	if (v["pen"]) {
      mixer.setFilterGroupSelectors('plastic-compat', '.pt-' + v["pen"].toString());
      if ((v["pen"].toString() == "start") || (v["pen"].toString() == "bp")) {
         jQuery(".collection-filter--createonly").prop("disabled", true);
      }
  }

	if (v["mat"]) mixer.setFilterGroupSelectors('plastic-material', '.pt-' + v["mat"].toString());
  if (v["type"]) mixer.setFilterGroupSelectors('plastic-type', '.pt-' + v["type"].toString());
	if (v["show"]) mixer.setFilterGroupSelectors('plastic-show', '.pt-' + v["show"].toString());
	mixer.parseFilterGroups();

}

function setDefault() {
   mixer.setFilterGroupSelectors('plastic-compat', '.pt-create');
	 mixer.parseFilterGroups();
}

//
// grab initial filter settings from URL
//
function getFilter() {

	var vars = deserializeHash();

	if (vars) {
		setDefault();
		menuJump(vars);
	} else {
    setDefault();
	}

}

//
// break down hash
//
function deserializeHash() {

	var hash = window.location.hash.replace(/^#/g, '');
	var obj = null;
	var groups = [];
	if (!hash) return obj;
	obj = {};
	groups = hash.split('&');
	groups.forEach(function(group) {
		var pair = group.split('=');
		var groupName = pair[0];
		obj[groupName] = pair[1].split(',');
	});
	return obj;

}

function removeClassByPrefix(el, prefix) {
    var regx = new RegExp('\\b' + prefix + '[^. ]*', 'g');
    el.className = el.className.replace(regx, '');
    return el;
}
